import React from 'react';
import Heading from '../CategoryPages/Heading';
import TopMenu from '../CategoryPages/TopMenu';


function Category() {
  return (
    <div className=''>
      <Heading />
      <TopMenu />
    </div>
  )
}

export default Category


